import { GAME_STATE, PLAYER_STATE } from '../constants/commonConstants';

// Compare authoritative snapshots, not animation booleans. Repeated snapshots
// are silent; a different card/action is audible even when the phase is unchanged.
export function gameActionSounds(previous, next) {
    if (!previous || !next || previous.roomId !== next.roomId) return [];
    const sounds = [];
    if (previous.gameState !== next.gameState) {
        if (next.gameState === GAME_STATE.playing) sounds.push('gameStartSound', 'shuffleSound');
        if (next.gameState === GAME_STATE.winDeclared) sounds.push('winDeclareSound');
        if (next.gameState === GAME_STATE.readyForNextMatch) sounds.push('showWinningSound');
    }
    if (previous.gameState === GAME_STATE.playing && next.gameState === GAME_STATE.playing) {
        const newDiscard = next.currentDiscardedCard?.cardId;
        if (newDiscard && newDiscard !== previous.currentDiscardedCard?.cardId) sounds.push('discardCardSound');
        const picked = next.players?.some(player => {
            const old = previous.players?.find(p => p.playerId === player.playerId);
            return [PLAYER_STATE.pickedDeckCard, PLAYER_STATE.pickedDiscardedCard].includes(player.playerState) &&
                (old?.playerState !== player.playerState || old?.turnStartedUtc !== player.turnStartedUtc);
        });
        if (picked || next.deckCardCount < previous.deckCardCount) sounds.push('pickCardSound');
    }
    return sounds;
}
